import { React, useContext } from "react";
import { ShopContext } from "../../context/ShopContext";
import { PRODUCTS } from "../../products";
import { CartItem } from "./CartItem";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const navigate = useNavigate();
  const { cartItems, getTotalCartAmount } = useContext(ShopContext);

  const totalAmount = getTotalCartAmount();

  return (
    <div className="cart">
      <div className="">{/* <h1> Cart Items</h1> */}</div>
      <div className="cartItems">
        {PRODUCTS.map((product) => {
          if (cartItems[product.id] !== 0) {
            return <CartItem data={product} />;
          }
        })}
      </div>
      {totalAmount > 0 ? (
        <div className="checkout">
          <p>Total Ammount: ${totalAmount}</p>
          <button className="btn" onClick={() => navigate("/")}>Continue Shopping</button>
          <button>Checkout</button>
        </div>
      ) : (
        <div className="empty-cart">
          <h2>Your cart is Empty</h2>
          <button className="btn" onClick={() => navigate("/")}>Continue Shopping</button>
        </div>
      )}
    </div>
  );
};

export default Cart;
